import $store from '../store';

export default value =>
  ($store.state.filters.reverseTextForLocals.includes($store.state.locale) ? 'revers-text' : value);



// WEBPACK FOOTER //
// ./src/filter/rtl-text-direction.js